var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaQs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2161_529)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2161_529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "#D9D9D9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5909 44V20.725H23.7292V24.24H19.0109V30.3517H22.1776V33.8667H19.0109V44H15.5909ZM24.4031 44L27.9181 20.725H32.0981L35.6131 44H32.2881L31.6548 39.25H28.3615L27.7281 44H24.4031ZM28.8365 35.64H31.1798L30.1981 27.8183L30.1031 26.5833H29.9131L29.8181 27.8183L28.8365 35.64ZM47.0502 45.7733C46.0897 45.7733 45.3086 45.5675 44.7069 45.1558C44.1052 44.7442 43.6513 44.2956 43.3452 43.81C43.1869 43.9261 42.9494 44.0264 42.6327 44.1108C42.3266 44.2058 42.0047 44.2533 41.6669 44.2533C40.6958 44.2533 39.883 44.0317 39.2286 43.5883C38.5741 43.145 38.0833 42.5433 37.7561 41.7833C37.4288 41.0233 37.2652 40.1683 37.2652 39.2183V25.5067C37.2652 24.5567 37.4447 23.7017 37.8036 22.9417C38.173 22.1817 38.7008 21.58 39.3869 21.1367C40.073 20.6933 40.8858 20.4717 41.8252 20.4717C42.7752 20.4717 43.588 20.6933 44.2636 21.1367C44.9497 21.58 45.4722 22.1817 45.8311 22.9417C46.2005 23.7017 46.3852 24.5567 46.3852 25.5067V39.2183C46.3852 39.8411 46.3008 40.4164 46.1319 40.9442C45.9736 41.4614 45.7888 41.8467 45.5777 42.1C45.715 42.3217 45.9102 42.4958 46.1636 42.6225C46.4169 42.7492 46.7125 42.8283 47.0502 42.86V45.7733ZM41.8252 40.9283C42.2475 40.9283 42.543 40.7594 42.7119 40.4217C42.8808 40.0733 42.9652 39.6722 42.9652 39.2183V25.5067C42.9652 25.0739 42.8808 24.6833 42.7119 24.335C42.543 23.9761 42.2475 23.7967 41.8252 23.7967C41.4136 23.7967 41.118 23.9761 40.9386 24.335C40.7697 24.6833 40.6852 25.0739 40.6852 25.5067V39.2183C40.6852 39.6722 40.775 40.0733 40.9544 40.4217C41.1338 40.7594 41.4241 40.9283 41.8252 40.9283ZM52.4462 44.2533C51.6967 44.2533 51.0423 44.1267 50.4829 43.8733C49.9234 43.62 49.459 43.2611 49.0895 42.7967C48.7201 42.3217 48.4404 41.7622 48.2504 41.1183C48.0709 40.4744 47.9812 39.7567 47.9812 38.965H50.9579C50.9579 39.6722 51.0687 40.2897 51.2904 40.8175C51.5226 41.3347 51.9079 41.5933 52.4462 41.5933C52.9106 41.5933 53.2115 41.3981 53.3487 41.0075C53.4859 40.6169 53.5545 40.1683 53.5545 39.6617C53.5545 39.0706 53.3223 38.4689 52.8579 37.8567C52.404 37.2339 51.929 36.6797 51.4329 36.1942C50.5779 35.3497 49.8654 34.5158 49.2954 33.6925C48.7359 32.8692 48.4562 31.9033 48.4562 30.795C48.4562 29.4861 48.7992 28.4306 49.4854 27.6283C50.1715 26.8261 51.1479 26.425 52.4145 26.425C53.1745 26.425 53.8131 26.5253 54.3304 26.7258C54.8581 26.9264 55.2804 27.2272 55.597 27.6283C55.9137 28.0294 56.1406 28.5203 56.2779 29.1008C56.4256 29.6814 56.4995 30.3517 56.4995 31.1117H53.5229C53.5229 30.5628 53.4648 30.0878 53.3487 29.6867C53.2326 29.2856 52.9423 29.085 52.4779 29.085C52.0979 29.085 51.8287 29.2486 51.6704 29.5758C51.512 29.8925 51.4329 30.2989 51.4329 30.795C51.4329 31.3756 51.5701 31.8928 51.8445 32.3467C52.1295 32.79 52.5992 33.3336 53.2537 33.9775C54.077 34.7797 54.8265 35.6347 55.502 36.5425C56.1881 37.4503 56.5312 38.4372 56.5312 39.5033C56.5312 40.2 56.4362 40.8386 56.2462 41.4192C56.0667 41.9997 55.7976 42.5011 55.4387 42.9233C55.0904 43.3456 54.6629 43.6728 54.1562 43.905C53.6601 44.1372 53.0901 44.2533 52.4462 44.2533Z",
    fill: "#020161"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2161_529",
    x: 0,
    y: 0,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2161_529"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2161_529",
    result: "effect2_dropShadow_2161_529"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2161_529",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2161_529",
    x: 4,
    y: 0,
    width: 63,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2161_529"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaQs);
export default __webpack_public_path__ + "static/media/FAQs.4311ffb00b83590f0f0fd7aace0dbbcf.svg";
export { ForwardRef as ReactComponent };